"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _commonCta = require("@mmc/common-cta");

var _cookieConsent = _interopRequireDefault(require("../styles/cookie-consent.css"));

var _cookieConsent2 = _interopRequireDefault(require("./cookie-consent.props/cookie-consent.defaultProps"));

var _cookieConsent3 = _interopRequireDefault(require("./cookie-consent.props/cookie-consent.propTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;

var renderMainHeading = function renderMainHeading(theme, mainHeading) {
  if ((0, _isEmpty2["default"])(mainHeading)) {
    return '';
  }

  return /*#__PURE__*/_react["default"].createElement("h2", {
    className: _cookieConsent["default"].mainHeading + " " + theme.headingFive
  }, mainHeading);
};

var renderParagraph = function renderParagraph(theme, paragraph) {
  if ((0, _isEmpty2["default"])(paragraph)) {
    return '';
  }
  /*
    This is a candidate for using the `dangerouslySetInnerHTML` prop
    to render the text string as paragraphs.  Other words to tag for search:
      * innerHTML
      * escaped HTML
      * xss
      * sanitize
      * sanitization
  */


  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _cookieConsent["default"].paragraph + " " + theme.smallType,
    dangerouslySetInnerHTML: {
      __html: paragraph
    }
  });
};

var CookieConsent = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CookieConsent, _React$Component);

  // All components need a resourceType in order for AEM to be aware of its existance
  CookieConsent.resourceType = function resourceType() {
    return 'CookieConsent_1_0_0';
  };

  function CookieConsent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasConsent: true
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = CookieConsent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* eslint-disable */
    if (typeof document !== 'undefined') {
      if (!document.cookie.includes('cookieConsent=true')) {
        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          hasConsent: false
        }));
      }
    }
    /* eslint-enable */

  };

  _proto.handleClick = function handleClick() {
    var hasConsent = this.state.hasConsent;

    if (hasConsent === false) {
      if (typeof document !== 'undefined') {
        // Here we're setting the cookie to have an expiration date of a year from the moment its created
        document.cookie = "cookieConsent=true; SameSite=Strict; path=/; expires=" + new Date(new Date().setFullYear(new Date().getFullYear() + 1)); // eslint-disable-line
      }

      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        hasConsent: true
      }));
    }
  };

  _proto.renderLink = function renderLink(theme, link) {
    if ((0, _isEmpty2["default"])(link) || (0, _isEmpty2["default"])(link.label)) {
      return '';
    }

    var updatedLink = JSON.parse(JSON.stringify(link));

    if (!(0, _isEmpty2["default"])(link.url)) {
      updatedLink.url = null;
    }

    if ((0, _isEmpty2["default"])(link.priority)) {
      updatedLink.priority = 'low';
    }

    return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: updatedLink,
      theme: theme,
      clickEvent: this.handleClick,
      classes: [_cookieConsent["default"]['cookie-consent-cta']]
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData;
    var hasConsent = this.state.hasConsent; // first we select the data from the larger query coming through

    var componentData = shouldUseDataOrDefaultProps(data, defaultData); // destructure items off data that the component needs

    var mainHeading = componentData.mainHeading,
        paragraph = componentData.paragraph,
        link = componentData.link;
    var renderedMainHeading = renderMainHeading(theme, mainHeading);
    var renderedParagraph = renderParagraph(theme, paragraph);
    var renderedLink = this.renderLink(theme, link);

    if ((0, _isEmpty2["default"])(renderedMainHeading) && (0, _isEmpty2["default"])(renderedParagraph) && (0, _isEmpty2["default"])(renderedLink)) {
      return '';
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "\n          " + _cookieConsent["default"]['cookie-consent'] + "\n        ",
      automation: "cookie-consent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "\n            " + _cookieConsent["default"]['cookie-consent-contents'] + "\n            " + (hasConsent ? '' : _cookieConsent["default"].isExpanded) + "\n            " + theme['container-fluid'] + "\n            " + theme.row + "\n            " + theme['middle-xs'] + "\n          "
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "\n              " + theme['col-xs-12'] + "\n              " + theme['col-sm-6'] + "\n              " + theme['col-sm-offset-1'] + "\n            "
    }, renderedMainHeading, renderedParagraph), /*#__PURE__*/_react["default"].createElement("div", {
      className: "\n              " + _cookieConsent["default"]['column-2'] + "\n              " + theme['col-xs-12'] + "\n              " + theme['col-sm-5'] + "\n              " + theme['center-xs'] + "\n            "
    }, renderedLink)));
  };

  return CookieConsent;
}(_react["default"].Component);

exports["default"] = CookieConsent;
CookieConsent.displayName = 'CookieConsent';
CookieConsent.defaultProps = {
  data: _cookieConsent2["default"],
  defaultData: _cookieConsent2["default"],
  theme: {}
};